export default __webpack_public_path__ + "504a492fb60058256228ac170dca2a15.png";